module.exports = __webpack_public_path__ + "code-reuse.3t8YGoQm.svg";